module.exports = __webpack_public_path__ + "static/media/кардио - велотренажер горизонтальныи.e6713b48.jpg";